import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-right",
  "use": "icon-chevron-right-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-chevron-right\">\n  <path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M7.807 3.999L6.5 5.066 10.886 10 6.5 14.934l1.307 1.067L13.5 10z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol